import { ReactComponent as Logo } from './onsa-logo.svg'

const OnsaLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <a href="https://onsa.ai" target="_blank" rel="noopener noreferrer" className={className}>
      <Logo />
    </a>
  )
}

export default OnsaLogo
